export const pl = {
  app: {
    name: 'QPRO Connect',
    rootMissing: '[QPRO CONNECT] Nie znaleziono elementu #root. Sprawdź index.html.',
    copyright: 'QPRO Connect. Wszelkie prawa zastrzeżone.',
  },
  nav: {
    home: 'Strona główna',
    listings: 'Ogłoszenia',
    companiesCatalog: 'Katalog firm',
    faq: 'FAQ',
    contact: 'Kontakt',
    accountMenuAria: 'Menu konta użytkownika',
    openMenuAria: 'Otwórz menu nawigacyjne',
    myAccount: 'Moje konto',
    myListings: 'Moje ogłoszenia',
    settings: 'Ustawienia',
    logout: 'Wyloguj się',
    login: 'Zaloguj się',
    register: 'Rejestracja',
    platform: 'Platforma',
    legal: 'Prawne',
    terms: 'Regulamin',
    privacy: 'Polityka prywatności',
    footerDescription:
      'Platforma dla branży transportowej - ogłoszenia, firmy, piloci i kierowcy w jednym miejscu.',
  },
  common: {
    loading: 'Ładowanie...',
    retry: 'Spróbuj ponownie',
    serverError:
      'Wystąpił błąd serwera (500). Pracujemy nad rozwiązaniem problemu. Spróbuj ponownie później.',
    displayedResults: 'Wyświetlono {{start}}-{{end}} z {{total}} wyników',
    verified: 'Zweryfikowana',
    highlighted: 'Wyróżniona',
    worker: 'Pracownik',
    unknownDate: 'Nieznana data',
    unknownListing: 'Nieznane ogłoszenie',
    listingWithoutTitle: 'Ogłoszenie bez tytułu',
    unknownPilot: 'Nieznany pilot',
    noAccess: 'Brak dostępu',
    email: 'E-mail',
    phone: 'Telefon',
    website: 'Strona WWW',
    location: 'Lokalizacja',
    taxId: 'NIP',
    regon: 'REGON',
    active: 'Aktywny',
    inactive: 'Nieaktywny',
    back: 'Wróć',
    fullScreen: 'Pełny ekran',
  },
  status: {
    open: 'Otwarte',
    closed: 'Zakończone',
    canceled: 'Anulowane',
  },
  preferences: {
    location: 'Lokalizacja',
    home: 'Dom',
    work: 'Praca',
    car: 'Samochód',
    explore: 'Eksploruj',
    map: 'Mapa',
    title: 'Preferowane lokalizacje',
    add: 'Dodaj lokalizację',
    addDialogTitle: 'Dodaj preferowaną lokalizację',
    info:
      'Te dane będą używane przez algorytm inteligentnego dobierania zleceń, aby dopasować ogłoszenia w Twojej okolicy.',
    loadError: 'Nie udało się załadować preferowanych lokalizacji.',
    deleteConfirm: 'Czy na pewno chcesz usunąć tę lokalizację?',
    deleteSuccess: 'Lokalizacja została usunięta.',
    deleteError: 'Nie udało się usunąć lokalizacji.',
    required: 'Tytuł i miejscowość są wymagane.',
    addSuccess: 'Lokalizacja została dodana.',
    addError: 'Nie udało się dodać lokalizacji.',
    empty: 'Nie dodałeś jeszcze żadnych preferowanych lokalizacji.',
    noLocation: 'Brak lokalizacji',
    radius: 'promień',
    titleLabel: 'Tytuł (np. Dom, Baza)',
  },
  auth: {
    checkingAccount: 'Sprawdzanie konfiguracji konta...',
    loginTitle: 'Logowanie',
    registerTitle: 'Rejestracja',
    email: 'Adres e-mail',
    password: 'Hasło',
    username: 'Nazwa użytkownika',
    signIn: 'Zaloguj się',
    createAccount: 'Utwórz konto',
    googleLogin: 'Kontynuuj z Google',
    googleRegister: 'Zarejestruj się z Google',
    noAccount: 'Nie masz konta?',
    hasAccount: 'Masz już konto?',
  },
  account: {
    dashboard: 'Pulpit',
    myListings: 'Moje ogłoszenia',
    favourites: 'Ulubione',
    sentApplications: 'Twoje aplikacje',
    myOrders: 'Moje zlecenia',
    listingsAndOffers: 'Ogłoszenia i oferty',
    receivedApplications: 'Nadesłane oferty',
    orders: 'Zlecenia',
    preferences: 'Preferowane lokalizacje',
    profile: 'Mój profil',
    messages: 'Wiadomości',
    settings: 'Ustawienia',
    userFallback: 'Użytkownik',
    welcome: 'Witaj w QPRO Connect, {{username}}!',
    dashboardDescription:
      'Z tego miejsca zarządzasz swoimi ogłoszeniami, wiadomościami i profilem. Poniżej znajdziesz skróty do najważniejszych sekcji.',
    activeListings: 'Aktywne ogłoszenia',
    unreadMessages: 'Nieprzeczytane wiadomości',
    browseListings: 'Przeglądaj ogłoszenia',
    addListing: 'Dodaj ogłoszenie',
    seeReceivedApplications: 'Zobacz nadesłane oferty',
    loadingDashboard: 'Ładowanie danych pulpitu...',
    loadingListings: 'Ładowanie ogłoszeń...',
    loadingProfile: 'Ładowanie danych profilu...',
    loadingSentApplications: 'Ładowanie Twoich aplikacji...',
    loadingMyOrders: 'Ładowanie Twoich zleceń...',
    loadingReceivedApplications: 'Ładowanie nadesłanych ofert...',
    noListingsTitle: 'Brak ogłoszeń',
    noListingsDescription:
      'Nie masz jeszcze żadnych ogłoszeń. Dodaj pierwsze ogłoszenie, by zacząć pozyskiwać zlecenia.',
    noFavouritesTitle: 'Brak zapisanych ogłoszeń',
    noFavouritesDescription:
      'Nie masz jeszcze żadnych zapisanych ogłoszeń. Przeglądaj katalog i dodawaj ogłoszenia do swojej listy.',
    noMessagesTitle: 'Brak wiadomości',
    noMessagesDescription:
      'Nie masz jeszcze żadnych wiadomości. Nawiąż kontakt z firmą lub pilotem, by rozpocząć rozmowę.',
    noSentApplicationsTitle: 'Brak wysłanych aplikacji',
    noSentApplicationsDescription:
      'Nie aplikowałeś jeszcze na żadne zlecenie. Przeglądaj ogłoszenia i znajdź coś dla siebie.',
    noMyOrdersTitle: 'Brak zleceń',
    noMyOrdersDescription:
      'Nie masz jeszcze zamkniętych ogłoszeń, do których zostałeś przypisany.',
    noReceivedApplicationsTitle: 'Brak nadesłanych ofert',
    noReceivedApplicationsDescription:
      'Nikt jeszcze nie zaaplikował na Twoje ogłoszenia.',
    noReceivedForListingDescription:
      'Nikt jeszcze nie odpowiedział na to ogłoszenie.',
    receivedCompanyOnly:
      'Nadesłane oferty są dostępne tylko dla kont firmy transportowej.',
    appliesToListing: 'Dotyczy ogłoszenia:',
    forListing: 'Oferty dla ogłoszenia',
    selectedListing: 'Wybrane ogłoszenie',
    allApplications: 'Wszystkie oferty',
    pilot: 'PILOT',
    pilotMessage: 'WIADOMOŚĆ OD PILOTA',
    pilotNoMessage: 'Pilot nie dodał treści wiadomości.',
    receivedAt: 'Otrzymano: {{date}}',
    sentAt: 'Wysłano: {{date}}',
    netPrice: 'Cena netto',
    vat: 'VAT',
  },
  listings: {
    pageTitle: 'Ogłoszenia transportowe',
    pageSubtitle:
      'Znajdź zlecenie lub ofertę dopasowaną do Twoich uprawnień i możliwości.',
    searchPlaceholder: 'Szukaj po tytule lub opisie',
    status: 'Status',
    dedication: 'Dedykacja',
    permissions: 'Uprawnienia',
    sort: 'Sortowanie',
    filters: 'Filtry',
    clearFilters: 'Wyczyść filtry',
    loading: 'Ładowanie ogłoszeń...',
    noResultsTitle: 'Brak ogłoszeń',
    noResultsDescription: 'Nie znaleziono ogłoszeń pasujących do wybranych filtrów.',
    details: 'Szczegóły',
    favorite: 'Dodaj do ulubionych',
    removeFavorite: 'Usuń z ulubionych',
    favoriteLoginRequired: 'Zaloguj się, aby dodać ogłoszenie do ulubionych.',
    favoriteAdded: 'Dodano do ulubionych.',
    favoriteRemoved: 'Usunięto z ulubionych.',
    favoriteError: 'Nie udało się zmienić statusu ulubionych.',
    apply: 'Aplikuj',
    applyTo: 'Aplikujesz na: {{title}}',
    applicationMessageHint:
      'Napisz krótką wiadomość do firmy transportowej, przedstawiając swoją ofertę.',
    sendApplication: 'Wyślij ofertę',
    sending: 'Wysyłanie...',
    workersOnly: 'Tylko pracownicy',
    detailedRoute: 'Szczegółowa trasa',
    startPlace: 'Miejscowość początkowa',
    endPlace: 'Miejscowość końcowa',
    map: 'Mapa',
    netValue: 'wartość netto',
    amountNotProvided:
      'W ogłoszeniu nie podano kwoty. Należy skontaktować się bezpośrednio z firmą w celu podjęcia negocjacji.',
    saveListing: 'Zapisz ogłoszenie',
    removeSavedListing: 'Usuń z zapisanych',
    applyTitle: 'Aplikuj na zlecenie',
    messageRequired: 'Treść wiadomości nie może być pusta.',
    applicationSent: 'Twoja aplikacja została wysłana!',
    applicationError: 'Wystąpił błąd podczas wysyłania aplikacji.',
    messageLabel: 'Treść Twojej wiadomości',
    messagePlaceholder:
      'Dzień dobry, jestem zainteresowany tym zleceniem. Posiadam wymagane uprawnienia i jestem dostępny w podanym terminie...',
    cancel: 'Anuluj',
    newest: 'Najnowsze',
    oldest: 'Najstarsze',
    sortValueDesc: 'Wartość malejąco',
    sortValueAsc: 'Wartość rosnąco',
    requiredPermissions: 'Wymagane uprawnienia',
    resultsSummary: 'Znaleziono {{total}} ogłoszeń',
    searchPlaceholderExtended: 'Wyszukaj po tytule, opisie, lokalizacji...',
    noResultsLong:
      'Nie znaleziono ogłoszeń pasujących do podanych kryteriów. Spróbuj zmienić filtry wyszukiwania.',
  },
  filters: {
    title: 'Filtry',
    city: 'Miejscowość',
    cityPlaceholder: 'Wpisz miasto',
    nipPlaceholder: 'Wpisz numer NIP',
    companyType: 'Typ firmy',
    onlyVerified: 'Tylko zweryfikowane',
    onlyHighlighted: 'Tylko wyróżnione',
    sort: 'Sortowanie',
    clear: 'Wyczyść filtry',
    pilotType: 'Typ pilota',
    allTypes: 'Wszystkie typy',
    permissions: 'Uprawnienia',
  },
  offline: {
    title: 'Brak połączenia',
    description:
      'Wygląda na to, że straciliśmy łączność z bazą. Sprawdź swoje połączenie internetowe i spróbuj ponownie.',
    factTitle: 'Ciekawostka transportowa',
    refresh: 'Odśwież stronę',
  },
  companies: {
    hubTitle: 'Katalog firm i pilotów',
    transportCompanies: 'Firmy transportowe',
    pilots: 'Piloci transportu',
    companyFallback: 'Firma transportowa',
    pilotFallback: 'Pilot',
    noCompaniesTitle: 'Brak firm',
    noCompaniesDescription: 'Nie znaleziono firm pasujących do wybranych filtrów.',
    noPilotsTitle: 'Brak pilotów',
    noPilotsDescription: 'Nie znaleziono pilotów pasujących do wybranych filtrów.',
    companyListings: 'Ogłoszenia firmy',
    noCompanyListingsTitle: 'Brak ogłoszeń',
    noCompanyListingsDescription:
      'Ta firma nie opublikowała jeszcze żadnych ogłoszeń.',
    certificates: 'Certyfikaty',
    gallery: 'Galeria',
    backToCompanies: 'Powrót do katalogu firm',
    backToCatalog: 'Powrót do katalogu',
    seeCompanyProfile: 'Zobacz profil firmy',
    unverifiedCompany:
      'Firma nie została zweryfikowana przez zespół QPRO Connect',
    unverifiedPilot:
      'Pilot nie został zweryfikowany przez zespół QPRO Connect',
    pageSubtitle:
      'Katalog zweryfikowanych firm transportowych działających na terenie całej Polski.',
    searchPlaceholder:
      'Szukaj po nazwie firmy, NIP lub danych kontaktowych...',
    resultsSummary: 'Znaleziono {{total}} firm',
  },
  pilots: {
    pageTitle: 'Piloci transportu',
    pageSubtitle: 'Katalog certyfikowanych pilotów dostępnych w systemie.',
    searchPlaceholder: 'Szukaj po imieniu lub nazwisku...',
    resultsSummary: 'Znaleziono {{total}} pilotów',
    noPilotsLong: 'Nie znaleziono pilotów pasujących do podanych kryteriów.',
    loadingProfile: 'Ładowanie profilu pilota...',
    notFound: 'Nie znaleziono pilota.',
    backToCatalog: 'Powrót do katalogu pilotów',
    noPermissions: 'Brak przypisanych uprawnień.',
    collaborateTitle: 'Nawiąż współpracę z pilotem',
    collaborateDescription:
      'Skontaktuj się z pilotem {{name}} bezpośrednio w celu ustalenia szczegółów zlecenia.',
    call: 'Zadzwoń',
    sendMessage: 'Wyślij wiadomość',
  },
  maps: {
    location: 'Lokalizacja',
    noGeodata: 'Brak danych geograficznych do wyświetlenia mapy.',
    startLocation: 'Miejscowość początkowa',
    endLocation: 'Miejscowość końcowa',
  },
  onboarding: {
    alreadyRegisteredTitle: 'Posiadasz już zarejestrowaną firmę',
    alreadyRegisteredDescription:
      'Twoje konto jest już powiązane z istniejącym profilem firmy lub pilota. Nie możesz utworzyć kolejnego.',
    goToDashboard: 'Przejdź do pulpitu',
    firstStepsTitle: 'Pierwsze kroki',
    firstStepsSubtitle:
      'Wybierz typ konta, który najlepiej odpowiada Twojej działalności, aby dokończyć konfigurację profilu.',
    companyTileTitle: 'Firma transportowa',
    companyTileDescription:
      'Zarządzaj flotą, dodawaj ogłoszenia i szukaj zleceń dla swoich pojazdów.',
    pilotTileTitle: 'Pilot B2B',
    pilotTileDescription:
      'Oferuj usługi pilotażu, zarządzaj swoimi uprawnieniami i zdobywaj nowe zlecenia.',
    letsStart: 'Zaczynajmy',
    companyTitle: 'Rejestracja firmy transportowej',
    companySubtitle:
      'Wypełnij poniższe dane, aby utworzyć profil swojej firmy w systemie.',
    companySection: 'Informacje o firmie',
    companyContactSection: 'Dane kontaktowe i adresowe',
    companyCreate: 'Utwórz profil firmy',
    pilotTitle: 'Rejestracja pilota B2B',
    pilotSubtitle:
      'Wypełnij poniższe dane, aby utworzyć swój profil pilota w systemie.',
    pilotPersonalSection: 'Dane osobowe',
    pilotPermissionsSection: 'Posiadane uprawnienia',
    pilotCompanySection: 'Dane firmy (B2B)',
    pilotCreate: 'Utwórz profil pilota',
    saving: 'Trwa zapisywanie...',
    fillName: 'Uzupełnij imię i nazwisko.',
    companyProfileError: 'Wystąpił błąd podczas tworzenia profilu firmy.',
    pilotProfileError: 'Wystąpił błąd podczas tworzenia profilu pilota.',
    enterCompanyName: 'Podaj nazwę firmy.',
    invalidNip: 'Podaj poprawny numer NIP.',
    invalidRegon: 'Podaj poprawny numer REGON.',
    invalidEmail: 'Podaj poprawny adres e-mail.',
    invalidPhone: 'Podaj poprawny numer telefonu albo zostaw pole puste.',
    invalidWebsite: 'Podaj poprawny adres strony internetowej.',
    invalidCoordinates: 'Podaj poprawne współrzędne albo pozostaw oba pola puste.',
  },
  content: {
    terms: 'Regulamin',
    privacy: 'Polityka prywatności',
    faq: 'Najczęściej zadawane pytania',
    contact: 'Kontakt',
  },
  forms: {
    companyName: 'Nazwa firmy',
    description: 'Opis działalności',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    city: 'Miasto',
    address: 'Adres',
    contactEmail: 'Email kontaktowy',
    phoneNumber: 'Numer telefonu',
    websiteUrl: 'Strona internetowa',
    latitude: 'Szerokość (Lat)',
    longitude: 'Długość (Lng)',
    iban: 'Numer konta IBAN',
    accountDetails: 'Dane konta',
    usernameRequired: 'Nazwa użytkownika *',
    emailRequired: 'Adres e-mail *',
    passwordRequired: 'Hasło *',
    repeatPassword: 'Powtórz hasło *',
    saveChanges: 'Zapisz zmiany',
    saving: 'Trwa zapisywanie...',
  },
  register: {
    fillRequired: 'Wypełnij wszystkie wymagane pola.',
    passwordPolicy:
      'Hasło musi mieć minimum 8 znaków, jedną cyfrę, jedną wielką literę, jedną małą literę i jeden znak specjalny.',
    passwordsMismatch: 'Hasła nie są identyczne.',
    acceptTerms: 'Musisz zaakceptować regulamin i politykę prywatności.',
    error: 'Wystąpił błąd podczas rejestracji. Spróbuj ponownie.',
    title: 'Zarejestruj się',
    subtitle: 'Dołącz do społeczności QPRO Connect',
    googleRegister: 'Zarejestruj się przez Google',
    submitting: 'Trwa rejestracja...',
    alreadyHaveAccount: 'Masz już konto?',
    acceptPrefix: 'Akceptuję',
  },
  callback: {
    unsupportedProvider: 'Ten dostawca logowania nie jest obsługiwany.',
    cancelled: 'Logowanie przez Google zostało przerwane lub odrzucone.',
    missingToken: 'Brakuje tokenu zwrotnego Google. Spróbuj ponownie.',
    success: 'Zalogowano przez Google.',
    backToLogin: 'Wróć do logowania',
    finishingTitle: 'Kończymy logowanie',
    finishingDescription: 'Trwa bezpieczna wymiana danych z Google i Strapi.',
    failedPrefix: 'Nie udało się dokończyć logowania przez Google:',
    failedGeneric: 'Nie udało się dokończyć logowania przez Google. Spróbuj ponownie.',
  },
  notifications: {
    unexpectedError: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
    profileUpdated: 'Profil został zaktualizowany.',
    invalidIban: 'Podaj poprawny numer IBAN albo zostaw pole puste.',
  },
  transportFacts: [
    'Największy ładunek kiedykolwiek przewieziony drogą lądową ważył ponad 15 000 ton - był to reaktor petrochemiczny w Arabii Saudyjskiej.',
    'Polskie drogi są częścią transeuropejskiej sieci transportowej TEN-T, której łączna długość przekracza 75 000 km.',
    'Pilot pojazdów ponadnormatywnych musi posiadać specjalne uprawnienia i może eskortować pojazdy do 7 metrów szerokości.',
    'Najdłuższy pociąg drogowy świata miał 1474 metry i 113 przyczep. Przejechał przez Australię.',
    'W Polsce każdego roku wydawanych jest ponad 2 miliony zezwoleń na transport ponadnormatywny.',
  ],
} as const;

export type PolishLanguagePack = typeof pl;
